(function() {
    if (customElements.get('base-equalizer') === undefined) {
        const template = document.createElement('template');
        template.innerHTML =  `
        <style>
        :host {
            display: block;
        }
        </style>
        <slot></slot>
        `;
        customElements.define('base-equalizer', class extends HTMLElement {
            constructor() {
                super();
                this.hooks = {
                    getHeight: (el) => el.offsetHeight,
                };
            }

            set getHeight(cb) {
                this.hooks.getHeight = cb;
                this.calculate();
            }

            get getHeight() {
                return this.hooks.getHeight;
            }

            get throttle() {
                return parseInt(this.getAttribute('throttle') ?? 25);
            }

            get items() {
                return Array.from(this.querySelectorAll(this.getAttribute('observe')));
            }

            connectedCallback() {
                this.init();
                new MutationObserver(() => this.init()).observe(this, {
                    subtree: true,
                    childList: true,
                });
            }

            init() {
                this.calculate();
                let timeout;
                const resizeObserver = new ResizeObserver((entries) => {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        this.calculate();
                    }, this.throttle);
                });
                this.items.forEach(el => {
                    resizeObserver.observe(el);
                });
            }
            calculate() {
                const items = this.items;
                let groups = {g0:[]};
                items.forEach(el => {
                    el.style.height = 'auto';
                    el.offsetHeight;
                    if (this.hasAttribute('rows')) {
                        let groupKey = `g${el.getBoundingClientRect().top}`;
                        if (groups[groupKey] === undefined) {
                            groups[groupKey] = [];
                        }
                        groups[groupKey].push(el);
                    } else {
                        groups.g0.push(el);
                    }
                });
                Object.getOwnPropertyNames(groups).forEach(group => {
                    const heights = groups[group].map(this.getHeight);
                    const max = Math.max(...heights);
                    groups[group].forEach(el => {
                        el.style.height = `${max}px`
                        el.offsetHeight;
                    });
                });
            }
        });
    }
})();
